import { render, staticRenderFns } from "./LaudoTecnicoTemplate.vue?vue&type=template&id=4faaf52e&scoped=true"
import script from "./LaudoTecnicoTemplate.vue?vue&type=script&lang=js"
export * from "./LaudoTecnicoTemplate.vue?vue&type=script&lang=js"
import style0 from "./LaudoTecnicoTemplate.vue?vue&type=style&index=0&id=4faaf52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faaf52e",
  null
  
)

export default component.exports